export default {
  imgBaseUrl: process.env.REACT_APP_IMAGES_BASE_URL,
  apiBaseUrl: process.env.REACT_APP_BASE_URL,
  languages: ['en', 'hy','ru'],
  default_lang: 'en',
};
